// Studyo Today Backend
// Package studyo.today.classroom.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/classroom/v1/resources/attachment.proto (package studyo.today.classroom.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/classroom/v1/resources/attachment.proto.
 */
export const file_studyo_today_classroom_v1_resources_attachment = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvY2xhc3Nyb29tL3YxL3Jlc291cmNlcy9hdHRhY2htZW50LnByb3RvEiNzdHVkeW8udG9kYXkuY2xhc3Nyb29tLnYxLnJlc291cmNlcyI/CgpBdHRhY2htZW50Eg0KBXRpdGxlGAEgASgJEhUKDXRodW1ibmFpbF91cmwYAiABKAkSCwoDdXJsGAMgASgJQiuqAihTdHVkeW8uVG9kYXkuQ2xhc3Nyb29tLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the message studyo.today.classroom.v1.resources.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_classroom_v1_resources_attachment, 0);

